import { Link } from 'react-router-dom'
import css from './options.css'
import { useGifDetailPermissions } from 'shared/hooks/use-permissions'

const ViewOptions = ({ className, gif }) => {
    const permissions = useGifDetailPermissions(gif.id)
    const { path } = gif
    return (
        <div className={className}>
            {permissions && permissions.edit && <Link className={css.edit} to={`${path}/edit`} />}
            <Link className={css.tile} to={`${path}/tile`} />
            <Link className={css.fullscreen} to={`${path}/fullscreen`} />
        </div>
    )
}

export default ViewOptions
